// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DwO1Z","toggleWrap":"styles_toggleWrap__jH24K","content":"styles_content__1a7Yo","selectAreaCode":"styles_selectAreaCode__2FwdC"};